const onboarding = {
  businessLogic: {
    title: 'Business Logic',

    areasOfOpertaion: {
      title: 'Zones Of Opertaion',
      subTitle: 'Show us where you operate. Pick a whole city, state or just a neighborhood, it is up to you.',
      hideLightZones: 'Highlight Zones',
    },

    operationPreferences: {
      title: 'Operation Preferences',
      subTitle: 'Help us to get to know you better.',

      form: {
        sections: {
          operationPrefernces: {
            header: 'What are your operation prefernces?',
            operationPreferncesOptions: {
              singleRides: 'Single Rides',
              sharedRides: 'Shared Rides',
            },
          },

          routingSettings: {
            header: 'Routing Settings',
            info: 'Max Doration: maximun duration of a trip. Max Stop: maximun stops in a trip. Ratio: 1.5 means that the duration of a person sitting in the vehicle will not exceed 150% of the time he would have spent driving alaone.. Max Passengers - maximum number of seats per trip.',

            fields: {
              maxDuration: 'Max Duration',
              paxAtOnce: 'Pax At Once',
              maxStops: 'Max Stops',
              jobsAtOnes: 'Jobs At Ones',
              maxPassengers: 'Max Passengers',
              rate: 'Rate',
              pickAll: 'Pick All',
            },
          },

          pickSettings: {
            header: 'Pick Settings',
            info: 'Max Doration: maximun duration of a trip. Max Stop: maximun stops in a trip. Ratio: 1.5 means that the duration of a person sitting in the vehicle will not exceed 150% of the time he would have spent driving alaone.. Max Passengers - maximum number of seats per trip.',

            fields: {
              ambulatory: 'Ambulatory (Min)',
              wheelchair: 'Wheelchair (Min)',
              maxEarly: 'Max Early (Min)',
              maxLate: 'Max Late (Min)',
            },
          },

          dropSettings: {
            header: 'Drop Settings',
            info: 'Max Doration: maximun duration of a trip. Max Stop: maximun stops in a trip. Ratio: 1.5 means that the duration of a person sitting in the vehicle will not exceed 150% of the time he would have spent driving alaone.. Max Passengers - maximum number of seats per trip.',

            fields: {
              ambulatory: 'Ambulatory (Min)',
              wheelchair: 'Wheelchair (Min)',
              maxEarly: 'Max Early (Min)',
              maxLate: 'Max Late (Min)',
            },
          },
        },
      },
    },

    fleetDefenition: {
      title: 'Fleet Defeninition',
      subTitle: 'Now, Lets talk fleet. Almost Done!',

      form: {
        sections: {
          assignmentPreferences: {
            header: 'What are your general Drivers Assignment prefernces?',
            fields: {
              defaultCarLocation: 'Default Car Location (Address)',
              maxDuration: 'Shift Max Duration (Minutes)',
            },
            assignmenOptions: {
              leastVehicles: 'Least Number <br/> of Vehicles',
              balacedVehicles: 'Balanced Routing',
            },
          },

          vehiclesAndDrivers: {
            header: 'How Many vehicles and drivers are there?',
            vehicles: 'Vehicles',
            drivers: 'Drivers',

            quickEntry: {
              header: 'QUICK ENTRY',
              fields: {
                numberOfVehicles: 'Number of Vehicles',
                wheelChairVehicles: 'Wheelchair Vehicles',
                numberOfDrivers: 'Number of Drivers',
                wheelChairDrivers: 'Wheelchair drivers',
              },
            },

            files: {
              header: 'Please, specify your In & Out Locations',
              explanation: 'Explanation about what it exactly mean. Explanation and more explanation and that could be enough.',
              example: 'Please make sure to address all attributes properly. ',
              exampleFileText: 'for the best result feel free to use our',
              exampleFile: 'example file',
              trySampleText: 'No data? ',
              trySampleBtn: 'Try a sample.',
            },

            uploadData: {
              header: 'UPLOAD DATA',
              firstLine: 'Please make sure to address all attributes. For the best results feel',
              secondLine: {
                firsTpart: 'free to use our',
                vehicle: 'Vehicles example file',
                and: 'and',
                drivers: 'Drivers example file',
              },
            },
          },
        },
      },
    },

    scheduleAutomation: {
      title: 'Schedule Automation',
      subTitle: 'Help us to get to know you better.',
    },

    additionalFeatures: {
      title: 'Additional Features',
      subTitle: 'The more we know the better service we will be able to provide.',

      form: {
        file: {
          header: 'Please, specify your In & Out Locations',
          explanation: 'Explanation about what it exactly mean. Explanation and more explanation and that could be enough.',
          example: 'Please make sure to address all attributes properly. ',
          exampleFileText: 'for the best result feel free to use our',
          exampleFile: 'example file',
          trySampleText: 'No data? ',
          trySampleBtn: ' Try a sample.',
        },

        willCall: {
          header: 'Do you wish to enable the "Will Call" option?',
          info: 'Max Doration: maximun duration of a trip. Max Stop: maximun stops in a trip. Ratio: 1.5 means that the duration of a person sitting in the vehicle will not exceed 150% of the time he would have spent driving alaone.. Max Passengers - maximum number of seats per trip.',
          on: 'On',
          off: 'Off',
          time: 'Time',
          attribute: 'Attribute',
          explanation: 'Please make sure to address the attribute property in you Demand files',
        },
      },
    },
  },

  assets: {
    title: 'Assets',
    fleetDefinition: {
      title: 'Fleet Definition',
      subTitle: 'Now, Lets talk fleet. Almost Done!',
    },
  },

  demand: {
    title: 'Demand',

    dataUpload: {
      title: 'Data Upload',
      subTitle: 'Feed me with the Demand and we are ready to go!',

      form: {
        file: {
          explanation: 'Please make sure to address all attributes properly. For the best result feel ',
          example: 'free to use our',
          exampleFile: 'example file',
          trySampleText: 'No data?',
          trySampleBtn: 'Try a sample.',
        },
      },
    },
  },

  save: 'Next',

  kpi: {
    title: 'STEPS COMPLETED',
    wellDone: 'Well Done!',
    labels: {
      onboardingKpiCompleted: 'Completed',
    },
  },

  submit: {
    text: 'And that\'s it! we are ready. if you are happy with your answers and don\'t want to change anything, go ahead and create you custom scenario.',
    create: 'CREATE SCENARIO',
  },
};

export default onboarding;
